import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0862f0d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control",
  placeholder: "Search this blog"
}, null, -1))
const _hoisted_3 = {
  class: "btn btn-secondary search-btn",
  type: "button"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Recent Posts")

import { ref } from 'vue';
import { BIconSearch } from 'bootstrap-icons-vue';
import BaseWidget from '@/blog/components/base/BaseWidget.vue';
import BaseWidgetTitle from '@/blog/components/base/BaseWidgetTitle.vue';
import BaseWidgetBody from '@/blog/components/base/BaseWidetBody.vue';
import RecentPostsList from '@/blog/components/shared/RecentPostsList.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const windowWidth = ref(window.innerWidth);
//
window.onresize = () => {
  windowWidth.value = window.innerWidth;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["", [windowWidth.value >= 1000 ? 'col-md-4' : 'col-lg-12']])
  }, [
    _createVNode(BaseWidget, null, {
      default: _withCtx(() => [
        _createVNode(BaseWidgetBody, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("button", _hoisted_3, [
                  _createVNode(_unref(BIconSearch))
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(BaseWidget, null, {
      default: _withCtx(() => [
        _createVNode(BaseWidgetTitle, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(BaseWidgetBody, null, {
          default: _withCtx(() => [
            _createVNode(RecentPostsList)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}
}

})